var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { StepperContainer, StepContainer, StepMain, Connector, ConnectorContainer, Step, LabelContainer, } from './styles';
var Stepper = function (_a) {
    var steps = _a.steps, activeStep = _a.activeStep, labels = _a.labels, isMobile = _a.isMobile, noMargin = _a.noMargin;
    var array = __spreadArray([], Array(steps), true);
    return (React.createElement(StepperContainer, { noMargin: noMargin }, array.map(function (_, index) { return (React.createElement(StepContainer, null,
        React.createElement(StepMain, null,
            React.createElement(React.Fragment, null,
                index !== 0 && (React.createElement(ConnectorContainer, null,
                    React.createElement(Connector, null))),
                React.createElement(Step, { active: activeStep === index + 1 },
                    React.createElement("span", null, index + 1)),
                labels && !isMobile && (React.createElement(LabelContainer, null,
                    React.createElement("span", null, labels[index]))))))); })));
};
export default Stepper;
